import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  AuthRole,
  getDefaultAuthenticatedPath,
  getSafeAuthRedirect,
} from '../utils/authRedirect';

export const SignedOutWorkerRouteRedirect = () => {
  const location = useLocation();
  const redirectPath = getSafeAuthRedirect(
    `${location.pathname}${location.search}`,
    'worker',
  );
  const loginPath = redirectPath
    ? `/login?${new URLSearchParams({ redirect: redirectPath }).toString()}`
    : '/login';

  return <Navigate to={loginPath} replace />;
};

export const SignedOutEmployerRouteRedirect = () => {
  const location = useLocation();
  const redirectPath = getSafeAuthRedirect(
    `${location.pathname}${location.search}`,
    'employer',
  );
  const params = new URLSearchParams({ role: 'employer' });
  if (redirectPath) params.set('redirect', redirectPath);

  return <Navigate to={`/register?${params.toString()}`} replace />;
};

interface AuthenticatedEntryRedirectProps {
  role?: AuthRole;
}

export const AuthenticatedEntryRedirect: React.FC<AuthenticatedEntryRedirectProps> = ({
  role,
}) => {
  const location = useLocation();
  const requestedRedirect = new URLSearchParams(location.search).get('redirect');
  const redirectPath = role ? getSafeAuthRedirect(requestedRedirect, role) : '';

  return (
    <Navigate
      to={redirectPath || getDefaultAuthenticatedPath(role)}
      replace
    />
  );
};
